const listeners = new Set();

export const notifyPendingApplicationsChanged = () => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch {
      // ignore listener errors
    }
  });
};

export const subscribePendingApplicationsChanged = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
